(function(){
'use strict';
var script=document.currentScript;
var labelTemplate=script&&script.dataset.photoLabel||'Show photo __NUMBER__ of __TOTAL__';
var groupLabel=script&&script.dataset.thumbnailsLabel||'Photo thumbnails';
function mount(track){
 if(track.dataset.visualThumbnailsReady)return;
 var slides=Array.from(track.children).filter(function(node){return node.querySelector('img');});
 if(slides.length<2)return;
 track.dataset.visualThumbnailsReady='true';
 var strip=document.createElement('div');strip.className='gccv-gallery-thumbnails';strip.setAttribute('role','group');strip.setAttribute('aria-label',groupLabel);
 var buttons=slides.map(function(slide,index){
  var source=slide.querySelector('img'),button=document.createElement('button'),image=document.createElement('img');
  button.type='button';button.className='gccv-gallery-thumbnail';button.setAttribute('aria-label',labelTemplate.replace('__NUMBER__',String(index+1)).replace('__TOTAL__',String(slides.length)));
  if(track.id)button.setAttribute('aria-controls',track.id);
  image.alt='';image.loading='lazy';image.decoding='async';image.width=144;image.height=104;
  var src=source.currentSrc||source.src;
  try{var url=new URL(src,document.baseURI);if(url.hostname==='cdn.shopify.com'||url.hostname===location.hostname)url.searchParams.set('width','160');src=url.href;}catch(error){}
  image.src=src;button.append(image);
  button.addEventListener('click',function(){track.scrollTo({left:slide.offsetLeft-slides[0].offsetLeft,behavior:'auto'});update();});
  strip.append(button);return button;
 });
 var controls=track.nextElementSibling;
 if(controls&&controls.classList.contains('gccv-gallery-controls'))controls.after(strip);else track.after(strip);
 var frame=0;
 function update(){
  var active=0;slides.forEach(function(slide,index){if(Math.abs(slide.offsetLeft-slides[0].offsetLeft-track.scrollLeft)<Math.abs(slides[active].offsetLeft-slides[0].offsetLeft-track.scrollLeft))active=index;});
  buttons.forEach(function(button,index){if(index===active)button.setAttribute('aria-current','true');else button.removeAttribute('aria-current');});
 }
 track.addEventListener('scroll',function(){if(frame)cancelAnimationFrame(frame);frame=requestAnimationFrame(function(){frame=0;update();});},{passive:true});
 update();
}
function init(){document.querySelectorAll('[data-gccv-master-gallery],[data-layout-gallery]').forEach(mount);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
document.addEventListener('shopify:section:load',function(){requestAnimationFrame(init);});
})();
